export default "/images/lokal.png?e4244a70eadbe567ce403e772a4bea7a";